import React from "react";

// types
import { CouponConfetti, CouponMessageCard, TradeDiscountSuccessCard } from "@swiggy-private/cart-types";
import { CouponPageType } from "@swiggy-private/checkout-core";

// helpers
import { getTradeDiscountCouponCard } from "@cart-ui/helpers/CouponModal";
import { isEmpty } from "@swiggy-private/core-ui";

// components
import CouponModal from "./CouponModal";

export interface CouponModalWrapperProps {
    couponSuccessData?: CouponMessageCard;
    couponErrorData?: CouponMessageCard;
    closeModal: VoidFunction;
    onClickCouponSavingsPopup: (context: string) => void;
    triggerConfettiByType?: (type: CouponConfetti) => void;
    isCouponAutoApplied: boolean;
    impressionAutoApplyCouponPopup?: VoidFunction;
    impressionOffercashSuccessPopup?: (isPHCallout?: boolean) => void;
    showCouponConfetti?: boolean;
    tradeDiscountCouponInfo?: TradeDiscountSuccessCard;
    onClickTDCouponModal?: VoidFunction;
    isNewPORFlow?: boolean;
    goToCouponListing?: (couponListingType: CouponPageType) => void;
    onImpressionMoreOffersStrip?: (data: Record<string, unknown>) => void;
    onClickMoreOffersStrip?: VoidFunction;
    onClickCouponSavingsPopupWithPOR?: (text: string) => void;
    onClickCouponMaxSavingsPopup?: (text: string) => void;
}

const CouponModalWrapper: React.FC<CouponModalWrapperProps> = ({
    couponSuccessData,
    couponErrorData,
    closeModal,
    onClickCouponSavingsPopup,
    triggerConfettiByType,
    isCouponAutoApplied,
    impressionAutoApplyCouponPopup,
    impressionOffercashSuccessPopup,
    showCouponConfetti,
    tradeDiscountCouponInfo,
    onClickTDCouponModal = (): void => void 0,
    isNewPORFlow,
    goToCouponListing,
    onImpressionMoreOffersStrip,
    onClickMoreOffersStrip,
    onClickCouponSavingsPopupWithPOR,
    onClickCouponMaxSavingsPopup,
}: CouponModalWrapperProps) => {
    if (!isEmpty(tradeDiscountCouponInfo)) {
        return (
            <CouponModal
                couponSuccessData={getTradeDiscountCouponCard(tradeDiscountCouponInfo)}
                closeModal={onClickTDCouponModal}
                onClickCouponSavingsPopup={onClickCouponSavingsPopup}
                isCouponAutoApplied={false}
                impressionAutoApplyCouponPopup={impressionAutoApplyCouponPopup}
                impressionOffercashSuccessPopup={impressionOffercashSuccessPopup}
                showCouponConfetti={showCouponConfetti}
            />
        );
    }

    return (
        <CouponModal
            couponErrorData={couponErrorData}
            couponSuccessData={couponSuccessData}
            closeModal={closeModal}
            onClickCouponSavingsPopup={onClickCouponSavingsPopup}
            onClickCouponSavingsPopupWithPOR={onClickCouponSavingsPopupWithPOR}
            triggerConfettiByType={triggerConfettiByType}
            isCouponAutoApplied={isCouponAutoApplied}
            impressionAutoApplyCouponPopup={impressionAutoApplyCouponPopup}
            impressionOffercashSuccessPopup={impressionOffercashSuccessPopup}
            showCouponConfetti={showCouponConfetti}
            isNewPORFlow={isNewPORFlow}
            goToCouponListing={goToCouponListing}
            onImpressionMoreOffersStrip={onImpressionMoreOffersStrip}
            onClickMoreOffersStrip={onClickMoreOffersStrip}
            onClickCouponMaxSavingsPopup={onClickCouponMaxSavingsPopup}
        />
    );
};

export default React.memo(CouponModalWrapper);
